import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  checkAppDeploymentVersion,
  recoverAppDeploymentPreloadError,
} from '../_services/appDeploymentRefresh.services.js';

const useAppDeploymentRefresh = () => {
  const location = useLocation();
  const firstCheckRef = useRef(true);

  useEffect(() => {
    const force = firstCheckRef.current;
    firstCheckRef.current = false;
    void checkAppDeploymentVersion({ force });
  }, [location.key, location.pathname, location.search]);

  useEffect(() => {
    const checkCurrentVersion = () => { void checkAppDeploymentVersion(); };
    const checkWhenVisible = () => {
      if (document.visibilityState === 'visible') checkCurrentVersion();
    };
    const handlePreloadError = (event) => {
      event?.preventDefault?.();
      recoverAppDeploymentPreloadError();
    };
    window.addEventListener('focus', checkCurrentVersion);
    window.addEventListener('online', checkCurrentVersion);
    window.addEventListener('vite:preloadError', handlePreloadError);
    document.addEventListener('visibilitychange', checkWhenVisible);
    return () => {
      window.removeEventListener('focus', checkCurrentVersion);
      window.removeEventListener('online', checkCurrentVersion);
      window.removeEventListener('vite:preloadError', handlePreloadError);
      document.removeEventListener('visibilitychange', checkWhenVisible);
    };
  }, []);
};

export default useAppDeploymentRefresh;
